import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import ar from "vee-validate/dist/locale/ar.json";
//import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import Vue from "vue";

import i18n from "../i18n";
// Install English and Arabic locales.
localize({
  en,
  ar,
});

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});
localize(i18n.locale);
// extend('required', required)
extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
      // valid: Array.isArray(value)
      //   ? value.length > 0
      //   : ["", null, undefined].indexOf(value) === -1,
    };
  },
  computesRequired: true,
});
extend("end_time_after_start", {
  params: ["startTime"],
  validate(value, { startTime }) {
    return value > startTime;
  },
  message: "يجب ان يكون وقت الانتهاء بعد وقت الابتداء",
});
extend("difference_in_period", {
  params: ["startTime", "period"],
  validate(value, { startTime, period }) {
    const toMinutes = (time) => {
      if (typeof time !== "string") return NaN;
      const match = time.match(/^([01]?\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/);
      if (!match) return NaN;
      return Number(match[1]) * 60 + Number(match[2]) + Number(match[3] || 0) / 60;
    };
    const duration = toMinutes(value) - toMinutes(startTime);
    const limit = Number(period);
    return Number.isFinite(limit) && limit > 0 && duration > 0 && duration <= limit;
  },
  message: (_, { period }) =>
    `يجب ألا يتجاوز الفرق بين وقت البداية والنهاية الفترة المحددة (${period} دقيقة)`,
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
